// import React, { useEffect, useState } from 'react'
// import { TextMediumBase, TextMediumSM } from '../../../../Components/Text/MediumText'
// import Breadcrumb from '../../../../Components/Utils/Breadcrumb'
// import { BackButton, CancelButton, CreateButton, SubmitButton } from '../../../../Components/Utils/Buttons'
// import axiosInstance from '../../../../Services/axiosCommon'
// import { useFormik } from 'formik'
// import UseEditData from '../../../../Components/Hooks/useEditData'
// import { ToggleRight } from 'lucide-react'
// import { HeadingWithIcon } from '../../../../Components/Utils/Settingheading'

// function ContractMenuIndex() {
//   const [data, setData] = useState([
//     {
//     enabled: true,
//     id: 1,
//     isDefault: true,
//     label: "Commissioning",
//     name: "commissioning"
//     },
//     {
//     enabled: true,
//     id: 2,
//     isDefault: true,
//     label: "Fire Extinguisher",
//     name: "fire_extinguisher"
//     },
//     {
//     enabled: true,
//     id: 3,
//     isDefault: true,
//     label: "Fire Suppression",
//     name: "fire_suppression"
//     },
//   ])
//   const [initialData, setInitialData] = useState([])
//   const { Oncancel, editData, isLoading } = UseEditData()

// //   function getData() {
// //     axiosInstance.get(`/alert-settings/otp-preference`)
// //       .then(res => {
// //         setData(res?.data?.data)
// //         setInitialData(JSON.parse(JSON.stringify(res?.data?.data))) // Deep copy for comparison
// //       })
// //       .catch(err => {
// //         console.log(err)
// //       })
// //   }

// //   useEffect(() => {
// //     getData()
// //   }, [])

//   function handleToggleChange(id) {
//     const updatedData = data.map(item => 
//       item.id === id ? { ...item, enabled: !item.enabled } : item
//     )
//     setData(updatedData)
//   }

//   const formik = useFormik({
//     enableReinitialize: true,
//     initialValues: {},
//     validateOnChange: false,
//     validateOnBlur: false,
//     onSubmit: (values, { resetForm }) => {
//       // Only submit if there are changes
//       const hasChanges = JSON.stringify(data) !== JSON.stringify(initialData)
      
//       if (!hasChanges) {
//         alert('No changes detected')
//         return
//       }

//       const payload = {
//         data: data.map(item => ({
//           id: item.id,
//           enabled: item.enabled,
//           isDefault: item.isDefault,
//           name:item.name
//         }))
//       }

//       editData(`/alert-settings/edit-otp`, payload, resetForm, `/settings/enableDisable`)
//         .then(() => {
//         //   getData() // Refresh data after successful update
//         })
//     }
//   })

//   const formatName = (text) => {
//     if (!text) return "-"
//     return text
//       .split("_")
//       .map(word => word.charAt(0).toUpperCase() + word.slice(1))
//       .join(" ")
//   }

//   return (
//     <div className="w-full h-full px-4 py-2 overflow-hidden">
//       <div className="w-full sm:flex justify-between items-center">
//         <Breadcrumb
//           items={[
//             { name: "Settings" },
//             { name: "Contract Menu" }
//           ]}
//         />
//         <div className=' flex justify-end'>
//            <BackButton />
//         </div>
       
//       </div>
      
//       <div className="w-full h-[calc(100vh-145px)] bg-white mt-3 mx-auto p-2 rounded-md overflow-y-scroll">
        
//                      <HeadingWithIcon icon={ToggleRight} title="Contract Additional Menu" />

//         <form onSubmit={formik.handleSubmit}>
//           <table className='w-full max-h-[calc(100vh-200px)] overflow-y-auto mt-2'>
//             <thead>
//               <tr>
//                 <th className='w-[60%] text-left text-sm font-medium py-2 px-4'>Menu</th>
//                 <th className='w-[40%] text-center text-sm font-medium py-2 px-4'>Enable / Disable</th>
//               </tr>
//             </thead>
//             <tbody>
//               {data && data.map((value, index) => (
//                 <tr className="even:bg-white odd:bg-slate-50" key={index}>
//                   <td className="w-[60%] py-2 text-left text-sm px-4">
//                     {value?.label}
//                   </td>
//                   <td className="w-[40%] py-2 text-center text-sm px-4">
//                     <label className="inline-flex items-center cursor-pointer">
//                       <input 
//                         type="checkbox" 
//                         checked={value?.enabled}
//                         onChange={() => handleToggleChange(value.id)}
//                         className="sr-only peer" 
//                       />
//                       <div className={`relative w-11 h-6 rounded-full peer 
//                         ${value?.enabled ? 'bg-baseColor-primary' : 'bg-gray-300'}`}>
//                         <div className={`absolute top-0.5 left-0.5 bg-white border-gray-300 border rounded-full h-5 w-5 transition-all 
//                           ${value?.enabled ? 'transform translate-x-5' : ''}`}>
//                         </div>
//                       </div>
//                       {/* <span className="ml-2 text-sm font-medium text-gray-900">
//                         {value?.enabled ? 'Enabled' : 'Disabled'}
//                       </span> */}
//                     </label>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
          
//           <div className="w-full mx-auto my-4 mt-8">
//             <div className="flex justify-end gap-4">
//               <CancelButton 
//                 handleClick={() => {
//                   setData(initialData) // Reset to initial data
//                 }}
//               />
//               <SubmitButton 
//                 disabled={isLoading || JSON.stringify(data) === JSON.stringify(initialData)}
//               />
//             </div>
//           </div>
//         </form>
//       </div>
//     </div>
//   )
// }

// export default ContractMenuIndex;


import React, { useEffect, useState } from 'react'
import Breadcrumb from '../../../../Components/Utils/Breadcrumb'
import { BackButton, CancelButton, SubmitButton } from '../../../../Components/Utils/Buttons'
import { useFormik } from 'formik'
import { ToggleRight } from 'lucide-react'
import { HeadingWithIcon } from '../../../../Components/Utils/Settingheading'
import UseEditData from '../../../../Components/Hooks/useEditData'

function ContractMenuIndex() {
  const [data, setData] = useState([
    { enabled: true, id: 1, isDefault: true, label: "Commissioning", name: "commissioning" },
    { enabled: true, id: 2, isDefault: true, label: "Fire Extinguisher", name: "fire_extinguisher" },
    { enabled: true, id: 3, isDefault: true, label: "Fire Suppression", name: "fire_suppression" },
  ])
  const [initialData, setInitialData] = useState([])
  const { Oncancel, editData, isLoading } = UseEditData()

  useEffect(() => {
    const savedSettings = localStorage.getItem("contractMenuSettings")
    if (savedSettings) {
      setData(JSON.parse(savedSettings))
      setInitialData(JSON.parse(savedSettings))
    } else {
      setInitialData(data)
    }
  }, [])

  function handleToggleChange(id) {
    const updatedData = data.map(item =>
      item.id === id ? { ...item, enabled: !item.enabled } : item
    )
    setData(updatedData)
    localStorage.setItem("contractMenuSettings", JSON.stringify(updatedData))
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {},
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (values, { resetForm }) => {
      const hasChanges = JSON.stringify(data) !== JSON.stringify(initialData)
      if (!hasChanges) {
        alert('No changes detected')
        return
      }

      const payload = {
        data: data.map(item => ({
          id: item.id,
          enabled: item.enabled,
          isDefault: item.isDefault,
          name: item.name
        }))
      }

      // editData(``, payload, resetForm, `/settings/contract-renewal`)
        .then(() => {
          localStorage.setItem("contractMenuSettings", JSON.stringify(data))
        })
    }
  })

  return (
    <div className="w-full h-full px-4 py-2 overflow-hidden">
      <div className="w-full sm:flex justify-between items-center">
        <Breadcrumb items={[{ name: "Settings" }, { name: "Contract Menu" }]} />
        <div className='flex justify-end'><BackButton /></div>
      </div>

      <div className="w-full h-[calc(100vh-145px)] bg-white mt-3 mx-auto p-2 rounded-md overflow-y-scroll">
        <HeadingWithIcon icon={ToggleRight} title="Additional Menus" />

        <form onSubmit={formik.handleSubmit}>
          <table className='w-full mt-2'>
            <thead>
              <tr>
                <th className='w-[60%] text-left text-sm font-medium py-2 px-4'>Menu</th>
                <th className='w-[40%] text-center text-sm font-medium py-2 px-4'>Enable / Disable</th>
              </tr>
            </thead>
            <tbody>
              {data.map((value, index) => (
                <tr className="even:bg-white odd:bg-slate-50" key={index}>
                  <td className="py-2 text-left text-sm px-4">{value.label}</td>
                  <td className="py-2 text-center text-sm px-4">
                    <label className="inline-flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        checked={value.enabled}
                        onChange={() => handleToggleChange(value.id)}
                        className="sr-only peer"
                      />
                      <div className={`relative w-11 h-6 rounded-full peer ${value.enabled ? 'bg-baseColor-primary' : 'bg-gray-300'}`}>
                        <div className={`absolute top-0.5 left-0.5 bg-white border-gray-300 border rounded-full h-5 w-5 transition-all ${value.enabled ? 'transform translate-x-5' : ''}`}></div>
                      </div>
                    </label>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="w-full mx-auto my-4 mt-8 flex justify-end gap-4">
            {/* <CancelButton handleClick={() => {
              setData(initialData)
              localStorage.setItem("contractMenuSettings", JSON.stringify(initialData))
            }} /> */}
            {/* <SubmitButton disabled={isLoading || JSON.stringify(data) === JSON.stringify(initialData)} /> */}
          </div>
        </form>
      </div>
    </div>
  )
}

export default ContractMenuIndex
